module.exports = __webpack_public_path__ + "static/media/Team.1a847e0d.jpg";